import { useRouter } from 'next/router';

import {
  ClubOffer,
  ContentfulQueryKeys,
  useContentfulQuery,
} from '@oresundsbron/api';

import { useSEOMetadata } from '~/hooks';
import { createMetaDataItems } from '../lib/metadata';
import { useLinksV2 } from './useLinksV2';

export function useClubOffer(id: string) {
  const { locale, isPreview } = useRouter();
  const { getLink } = useLinksV2();

  const { data, isFetched, isLoading } = useContentfulQuery<ClubOffer>(
    ContentfulQueryKeys.ClubOffer({
      id,
      locale,
      preview: isPreview,
    }),
    (q) =>
      q.Club.offer({
        id,
        preview: isPreview,
        locale,
      })
  );

  const link = getLink(id);
  const mainImage = data?.images[0];

  const metadataItems = createMetaDataItems({
    ...data,
    mainImage,
    link,
    contentType: 'article',
  });

  const seoMetadata = useSEOMetadata(data?.metadata, metadataItems);

  return {
    data,
    isLoading: !isFetched || isLoading,
    seoMetadata,
  };
}
